module.exports = __webpack_public_path__ + "static/img/speedfly.3fb9a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/speedfly.png
// module id = QFv8
// module chunks = 0